import React, {useState} from 'react'
import {Modal, Form, Row, Col, Container} from 'react-bootstrap'
// import FormPass from 'components/componentsmall/form_pass'
import './style.css'

export default function AkunKurir() {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
  
    return (
      <>
        <button onClick={handleShow}>
          Lengkapi data kurir
        </button>
  
        <Modal className="ber-update-profile" size="xl" show={show} onHide={handleClose} animation={false}>
          <Modal.Header closeButton>
            <Modal.Title>Lengkapi data kurir</Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <Container>
              <div className="akun-content-berberkah">
                  <Form.Group as={Row} className="mb-3">
                      <Form.Label column md="2">
                          Nama
                      </Form.Label>
                      <Col md={10}>
                          <Form.Control type="text" placeholder="Nama" />
                          <small>(Contoh : Umar Sabirin)</small>
                      </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3">
                      <Form.Label column md="2">
                          Nomor Hp
                      </Form.Label>
                      <Col md={10}>
                          <Form.Control type="tel" placeholder="Nomor Hp" />
                          <small>(Contoh : 0812-3456-7890)</small>
                      </Col>
                  </Form.Group>
              </div>
          </Container>
          </Modal.Body>
          <Modal.Footer>
            <button onClick={handleClose}>
              Selesai
            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
  